import { Component, HostBinding, Input, HostListener, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResponsiveService, GridModule } from '@onep/ng-uikit-lib/grid';
import { BehaviorSubject } from 'rxjs';
import { ScrollingModule } from '@angular/cdk/scrolling';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@onep/ng-uikit-lib/grid';
import * as ɵngcc2 from '@angular/common';

const _c0 = function (a0) { return { "width": a0 }; };
function HeaderComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 3);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(1, _c0, ctx_r0.stepperCurrentStep / ctx_r0.stepperTotalSteps * 100 + "%"));
} }
const _c1 = [[["onep-header-left"]], [["onep-header-center"]], [["onep-header-right"]]];
const _c2 = function (a0) { return { "onep-header-divider": a0 }; };
const _c3 = ["onep-header-left", "onep-header-center", "onep-header-right"];
const _c4 = ["*"];
function HeaderStepperComponent_p_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 2);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate3("", ctx_r0.stepperLabel, " ", ctx_r0.currentStep, "/", ctx_r0.totalSteps, "");
} }
class HeaderComponent {
    constructor(responsiveService) {
        this.responsiveService = responsiveService;
        this.subscriptions = [];
        this.headerWithStepper = false;
        /**
         * Displays a stepper
         */
        this.stepper = false;
        /**
         * Sets the current step if has a stepper
         */
        this.stepperCurrentStep = 0;
        /**
         * Sets the total steps if has a stepper
         */
        this.stepperTotalSteps = 0;
        this.displayHeaderLine = true;
        this.displayHeaderLineOnScroll = false;
        this.scrollSubject = new BehaviorSubject(false);
        this.scrollState$ = this.scrollSubject.asObservable();
    }
    onScroll() {
        this.scrollSubject.next(window.pageYOffset > 15);
    }
    ngOnInit() {
        if (this.displayHeaderLineOnScroll) {
            this.subscriptions.push(this.scrollState$.subscribe((v) => {
                this.displayHeaderLine = v;
            }));
        }
        this.headerWithStepper =
            !!this.stepper &&
                this.stepperTotalSteps > 0 &&
                this.stepperCurrentStep > 0;
    }
    ngOnChanges() {
        this.headerWithStepper =
            !!this.stepper &&
                this.stepperTotalSteps > 0 &&
                this.stepperCurrentStep > 0;
    }
    ngOnDestroy() {
        this.subscriptions.forEach((s) => s.unsubscribe());
    }
}
HeaderComponent.ɵfac = function HeaderComponent_Factory(t) { return new (t || HeaderComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ResponsiveService)); };
HeaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HeaderComponent, selectors: [["onep-header"], ["onep-header-modal"]], hostVars: 2, hostBindings: function HeaderComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("scroll", function HeaderComponent_scroll_HostBindingHandler() { return ctx.onScroll(); }, false, ɵngcc0.ɵɵresolveWindow);
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("onep-header-with-stepper", ctx.headerWithStepper);
    } }, inputs: { stepper: "stepper", stepperCurrentStep: "stepperCurrentStep", stepperTotalSteps: "stepperTotalSteps", displayHeaderLine: "displayHeaderLine", displayHeaderLineOnScroll: "displayHeaderLineOnScroll" }, features: [ɵngcc0.ɵɵProvidersFeature([ResponsiveService]), ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c3, decls: 6, vars: 4, consts: [[1, "onep-header-content"], [3, "ngClass"], ["class", "onep-header-progress-bar", 3, "ngStyle", 4, "ngIf"], [1, "onep-header-progress-bar", 3, "ngStyle"]], template: function HeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c1);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵprojection(2, 1);
        ɵngcc0.ɵɵprojection(3, 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 1);
        ɵngcc0.ɵɵtemplate(5, HeaderComponent_div_5_Template, 1, 3, "div", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c2, ctx.displayHeaderLine));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.headerWithStepper);
    } }, dependencies: [ɵngcc2.NgClass, ɵngcc2.NgIf, ɵngcc2.NgStyle], encapsulation: 2 });
HeaderComponent.ctorParameters = () => [
    { type: ResponsiveService }
];
HeaderComponent.propDecorators = {
    headerWithStepper: [{ type: HostBinding, args: ['class.onep-header-with-stepper',] }],
    stepper: [{ type: Input }],
    stepperCurrentStep: [{ type: Input }],
    stepperTotalSteps: [{ type: Input }],
    displayHeaderLine: [{ type: Input }],
    displayHeaderLineOnScroll: [{ type: Input }],
    onScroll: [{ type: HostListener, args: ['window:scroll',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HeaderComponent, [{
        type: Component,
        args: [{
                selector: 'onep-header, onep-header-modal',
                template: "<div class=\"onep-header-content\">\n  <ng-content select=\"onep-header-left\"></ng-content>\n  <ng-content select=\"onep-header-center\"></ng-content>\n  <ng-content select=\"onep-header-right\"></ng-content>\n</div>\n<div [ngClass]=\"{\n'onep-header-divider': displayHeaderLine\n}\">\n  <div *ngIf=\"headerWithStepper\" [ngStyle]=\"{'width': (this.stepperCurrentStep / this.stepperTotalSteps) * 100 + '%'}\" class=\"onep-header-progress-bar\"></div>\n</div>\n",
                providers: [ResponsiveService]
            }]
    }], function () { return [{ type: ɵngcc1.ResponsiveService }]; }, { headerWithStepper: [{
            type: HostBinding,
            args: ['class.onep-header-with-stepper']
        }], stepper: [{
            type: Input
        }], stepperCurrentStep: [{
            type: Input
        }], stepperTotalSteps: [{
            type: Input
        }], displayHeaderLine: [{
            type: Input
        }], displayHeaderLineOnScroll: [{
            type: Input
        }], onScroll: [{
            type: HostListener,
            args: ['window:scroll']
        }] }); })();

class HeaderLeftComponent {
    constructor() { }
    ngOnInit() { }
}
HeaderLeftComponent.ɵfac = function HeaderLeftComponent_Factory(t) { return new (t || HeaderLeftComponent)(); };
HeaderLeftComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HeaderLeftComponent, selectors: [["onep-header-left"]], ngContentSelectors: _c4, decls: 1, vars: 0, template: function HeaderLeftComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
HeaderLeftComponent.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HeaderLeftComponent, [{
        type: Component,
        args: [{
                selector: 'onep-header-left',
                template: "<ng-content></ng-content>\n"
            }]
    }], function () { return []; }, null); })();

class HeaderCenterComponent {
    constructor() { }
    ngOnInit() { }
}
HeaderCenterComponent.ɵfac = function HeaderCenterComponent_Factory(t) { return new (t || HeaderCenterComponent)(); };
HeaderCenterComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HeaderCenterComponent, selectors: [["onep-header-center"]], ngContentSelectors: _c4, decls: 1, vars: 0, template: function HeaderCenterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
HeaderCenterComponent.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HeaderCenterComponent, [{
        type: Component,
        args: [{
                selector: 'onep-header-center',
                template: "<ng-content></ng-content>\n"
            }]
    }], function () { return []; }, null); })();

class HeaderRightComponent {
    constructor() { }
    ngOnInit() { }
}
HeaderRightComponent.ɵfac = function HeaderRightComponent_Factory(t) { return new (t || HeaderRightComponent)(); };
HeaderRightComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HeaderRightComponent, selectors: [["onep-header-right"]], ngContentSelectors: _c4, decls: 1, vars: 0, template: function HeaderRightComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
HeaderRightComponent.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HeaderRightComponent, [{
        type: Component,
        args: [{
                selector: 'onep-header-right',
                template: "<ng-content></ng-content>\n"
            }]
    }], function () { return []; }, null); })();

class HeaderStepperComponent {
    constructor() {
        this.stepperTitle = '';
        this.currentStep = 1;
        this.totalSteps = 1;
        this.stepperLabel = '';
    }
    ngOnInit() { }
}
HeaderStepperComponent.ɵfac = function HeaderStepperComponent_Factory(t) { return new (t || HeaderStepperComponent)(); };
HeaderStepperComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HeaderStepperComponent, selectors: [["onep-header-stepper"]], inputs: { stepperTitle: "stepperTitle", currentStep: "currentStep", totalSteps: "totalSteps", stepperLabel: "stepperLabel" }, decls: 3, vars: 2, consts: [[1, "onep-text-body-1"], ["class", "onep-header-stepper-label", 4, "ngIf"], [1, "onep-header-stepper-label"]], template: function HeaderStepperComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(2, HeaderStepperComponent_p_2_Template, 2, 3, "p", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.stepperTitle);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !(ctx.currentStep === 1 && ctx.currentStep === ctx.totalSteps));
    } }, dependencies: [ɵngcc2.NgIf] });
HeaderStepperComponent.ctorParameters = () => [];
HeaderStepperComponent.propDecorators = {
    stepperTitle: [{ type: Input }],
    currentStep: [{ type: Input }],
    totalSteps: [{ type: Input }],
    stepperLabel: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HeaderStepperComponent, [{
        type: Component,
        args: [{ selector: 'onep-header-stepper', template: "<p class=\"onep-text-body-1\">{{stepperTitle}}</p>\n<p *ngIf=\"!(currentStep === 1 && currentStep === totalSteps)\" class=\"onep-header-stepper-label\">{{stepperLabel}} {{currentStep}}/{{totalSteps}}</p>\n" }]
    }], function () { return []; }, { stepperTitle: [{
            type: Input
        }], currentStep: [{
            type: Input
        }], totalSteps: [{
            type: Input
        }], stepperLabel: [{
            type: Input
        }] }); })();

class HeaderModule {
}
HeaderModule.ɵfac = function HeaderModule_Factory(t) { return new (t || HeaderModule)(); };
HeaderModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HeaderModule });
HeaderModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule, ScrollingModule, GridModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HeaderModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    HeaderComponent,
                    HeaderLeftComponent,
                    HeaderCenterComponent,
                    HeaderRightComponent,
                    HeaderStepperComponent
                ],
                imports: [CommonModule, ScrollingModule, GridModule],
                exports: [
                    HeaderComponent,
                    HeaderLeftComponent,
                    HeaderCenterComponent,
                    HeaderRightComponent,
                    HeaderStepperComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HeaderModule, { declarations: function () { return [HeaderComponent, HeaderLeftComponent, HeaderCenterComponent, HeaderRightComponent, HeaderStepperComponent]; }, imports: function () { return [CommonModule, ScrollingModule, GridModule]; }, exports: function () { return [HeaderComponent, HeaderLeftComponent, HeaderCenterComponent, HeaderRightComponent, HeaderStepperComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { HeaderCenterComponent, HeaderComponent, HeaderLeftComponent, HeaderModule, HeaderRightComponent, HeaderStepperComponent };

